import ListCard from "@/components/census/ListCard";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AcuityLevel, acuityLevels } from "./shared/util";

@Component({
  components: { ListCard }
})
export default class CensusListAcuity extends Vue {
  @Prop(Array)
  patients!: Array<Patient>;

  @Prop(String)
  itemComponent!: string;

  @Getter("area", patientNamespace)
  area!: string;

  acuityLevels: Array<AcuityLevel> = acuityLevels;

  get census() {
    return this.patients
      .map(p => p.census)
      .filter(census => {
        return !census.roomEmpty;
      })
      .sort((a, b) => {
        // Convert discharge to be shown last
        const aComputedLevel = a.acuityLevel === 4 ? -1 : a.acuityLevel;
        const bComputedLevel = b.acuityLevel === 4 ? -1 : b.acuityLevel;
        const al = bComputedLevel - aComputedLevel;
        if (al) {
          return al;
        } else {
          return b.maxAlertLevel - a.maxAlertLevel;
        }
      });
  }
}
